import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle, Children, memo } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    TextField,
    FormGroup,
    FormControlLabel,
    Switch,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    InputAdornment,
    IconButton,
    Tooltip,
    Typography,
    Chip,
    ButtonGroup,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { AddBox, AddCircle, CallSplit, CheckBox, CheckBoxOutlineBlank, ColorLens, Edit, PlayArrow, RemoveCircle, Save, Search, Undo } from '@mui/icons-material';

import { checkComponentPresence, getCategoryColor, makeid, myTimestampToDate, propComparator, propComparatorDate } from '../utils/ui_utils';

import { globalstyles } from '../lib/definitions';

import DeleteconfirmationSection from '../components/DeleteConfirmationSection';
import { get_Cow_list, update_cows_param } from '../FirebaseUtils/dbCow';
import { useEvent } from '../context/eventContext';
import { getCowLight } from '../definitions/cow';
import { MyInput } from '../components/MyInput';
import { chunk } from 'lodash';
import { addMinutes, differenceInMonths, format } from 'date-fns';
import { PropertyButton, PropertyLabel } from '../definitions/property';
import { DateTimePicker } from '@mui/x-date-pickers';
import { PresenceIcon, TogglePresenceButton } from '../components/PresenceButton';
import { MyCloseBtn } from '../components/MyButtons';

const selection_mode_list = [
    { id: 'group', label: 'selezionamento raggruppato' },
    { id: 'single', label: 'selezionamento singolo' }
]


export const MatchSplitDialog = forwardRef(({ splitFn }, ref) => {

    const childRefDelete = useRef()
    const { seEvent } = useEvent()
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [open, setOpen] = useState(false);

    const [curElement, setCurElement] = useState({})
    const [newElement, setNewElement] = useState({})
    const [cow_list, setCowList] = useState([])
    const [splitIndex, setSplitIndex] = useState(-1)
    const [showNotPresent, setShowNotPresent] = useState(false)
    const [selectionMode, setSelectionMode] = useState('group')
    const [selectedElements, setSelectedElements] = useState([])
    const handleClose = () => {
        setOpen(false);
    };


    useImperativeHandle(ref, () => {
        return {
            onOpen(el, cl) {
                setOpen(true);
                setCurElement({ ...el, cow_list: cl.filter(c => c.is_present === true) })
                setCowList(cl)
                let _el = { ...el }
                _el.cow_list = []
                _el.planned_start = addMinutes(myTimestampToDate(_el.planned_start), 20)
                setNewElement(_el)
                setIsEdited(false)
                console.log("CALC", cl.filter(c => c.is_present === true).length, cl.filter(c => c.is_present === true).length / 2, Math.ceil(cl.filter(c => c.is_present === true).length / 2))
                const c_length = cl.length - Math.ceil(cl.filter(c => c.is_present === true).length / 2)
                setSelectedElements(Array.from({ length: c_length }, (_, i) => cl.length - i - 1))
            }
        }
    })

    const toggleSelect = (k) => {
        if (selectionMode === 'group') {
            const c_length = curElement.cow_list.length - k
            setSelectedElements(Array.from({ length: c_length }, (_, i) => curElement.cow_list.length - i - 1))
        } else {
            setSelectedElements(s => {
                let _s = [...s]
                const c = s.indexOf(k)
                if (c >= 0) {
                    _s.splice(c, 1)
                } else {
                    _s.push(k)
                }
                return _s
            })
        }
        //setSplitIndex(k)

    }


    const handleSave = () => {
        const cb = () => {
            splitFn(curElement, newElement)
            setOpen(false)
        }
        childRefDelete.current.confirmDelete('Conferma divisione gara', `Verranno modificate anche le eventuali gare a cui la gara sorgente e collegata, collegandovi la nuova gara creata`, cb)
    }


    const onChangeHandler = (el,) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (value !== undefined) {
            setCurElement(c => ({ ...c, [name]: value }))
            setIsEdited(true)
        }
    }


    const onChangeHandlerNew = (el,) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (value !== undefined) {
            setNewElement(n => ({ ...n, [name]: value }))
            setIsEdited(true)
        }
    }


    const doSplit = () => {
        let sublist = []
        let c_list = []
        if (curElement.cow_list.length > 0) {
            c_list = curElement.cow_list
        } else {
            c_list = cow_list
        }
        //c_list = c_list.filter(c => showNotPresent || c.is_present === true).sort(propComparatorDate('birthdate'))
        let s0 = []
        let s1 = []
        console.log(c_list)
        for (let c = 0; c < c_list.length; c++) {

            console.log(c, selectedElements.includes(c), c_list[c])
            if (selectedElements.includes(c)) {
                s1.push(c_list[c])
            } else {
                s0.push(c_list[c])
            }
        }
        sublist = [s0, s1]
        //  sublist = chunk(curElement.cow_list.filter(c => showNotPresent || c.is_present=== true).sort(propComparator('catalog_id')), splitIndex)

        //    sublist = chunk(cow_list.filter(c => showNotPresent || c.is_present=== true).sort(propComparator('catalog_id')), splitIndex)
        console.log(sublist)


        setCurElement(c => ({ ...c, from_split: true, cow_list: sublist[0].map(c => ({ ...c, is_in_ring: true })) }))
        setNewElement(c => ({ ...c, from_split: true, cow_list: sublist[1].map(c => ({ ...c, is_in_ring: true })) }))
        setSelectedElements([])
        setIsEdited(true)
    }


    const undoSplit = () => {
        setCurElement(c => ({ ...c, cow_list: cow_list.filter(c => showNotPresent || c.is_present === true), from_split: false }))
        setNewElement(c => ({ ...c, cow_list: [] }))
        setIsEdited(false)
    }


    const checkNotValid = () => {
        if (curElement.match_name === newElement.match_name) {
            return true
        }
        if (newElement.cow_list.length === 0) {
            return true
        }
        return false
    }



    return (
        <div>

            <Dialog open={open} onClose={handleClose} fullScreen={true}>
                <DeleteconfirmationSection ref={childRefDelete} />
                <DialogTitle>
                    Dividi gara in 2

                    <ButtonGroup>
                        <Button onClick={doSplit} variant="contained" size="small" startIcon={<PlayArrow />}>Dividi lista soggetti selezionati ({selectedElements.length}/{cow_list.filter(c => c.is_present).length - splitIndex})</Button>
                        <Button onClick={undoSplit} variant="outlined" size="small" startIcon={<Undo />}>Annulla</Button>
                    
                        {selection_mode_list.map((s, k) => (
                            <Button size="small" key={k} onClick={() => setSelectionMode(s.id)} variant={selectionMode === s.id ? 'contained' : 'outlined'} color="secondary">{s.label}</Button>
                        ))}
                    </ButtonGroup>
                    {/*                     <TogglePresenceButton setShowNotPresent={setShowNotPresent} showNotPresent={showNotPresent} />
 */}                </DialogTitle>
                <DialogContent>
                    <Grid container flexDirection={"row"} spacing={1}>
                        <Grid size="grow">
                            <Grid container sx={globalstyles.sectionHeader}>
                                <Grid size="grow">
                                    <Typography>
                                        GARA 1
                                    </Typography>
                                </Grid>
                                <Grid size="auto">
                                    <Typography sx={globalstyles.listHeader}>
                                        Soggetti <Chip size="small" color="secondary" label={curElement.cow_list?.length} />
                                    </Typography>
                                </Grid>
                            </Grid>
                            <MyInput
                                id="match_name"
                                label={'Nome'}
                                value={curElement.match_name}
                                onChange={(ev) => onChangeHandler(ev.target)}
                            />
                            <MyInput
                                id="match_description"
                                label={'Descrizione'}
                                value={curElement.match_description}
                                onChange={(ev) => onChangeHandler(ev.target)}
                            />
                            <Grid xs={6} container alignItems={"end"} alignContent={"center"} sx={{ mb: 1 }}>
                                {curElement.planned_start &&
                                    <DateTimePicker
                                        variant="outlined"
                                        size="small"
                                        sx={{ mt: 0.8 }}
                                        label={'inizio previsto'}
                                        name={'planned_start'}
                                        id={'planned_start'}
                                        slotProps={{ field: { size: 'small' } }}
                                        value={myTimestampToDate(curElement.planned_start)}
                                        onChange={(nv) => onChangeHandler({ value: nv, name: 'planned_start' })} />
                                }
                            </Grid>
                            <Box>
                                <Grid container sx={globalstyles.listHeader}>
                                    <Grid size={0.5}>
                                    </Grid>
                                    <Grid size={0.5}>
                                        Cat
                                    </Grid>
                                    <Grid size={2}>
                                        Matricola
                                    </Grid>
                                    <Grid size="grow">
                                        Nome
                                    </Grid>
                                    <Grid size="grow">
                                        Proprietà
                                    </Grid>
                                    <Grid size={1}>
                                        Parti
                                    </Grid>
                                    <Grid size={1}>
                                        Età (mesi)
                                    </Grid>
                                    <Grid size={1}>
                                        Data di nascita
                                    </Grid>
                                </Grid>
                                {curElement.cow_list?.map((c, k) => (
                                    <OneCow cow={c} key={k}
                                        toggleSelect={toggleSelect}
                                        //is_selected={k >= splitIndex}
                                        is_selected={selectedElements.includes(k)}
                                        index={k} />
                                ))}
                            </Box>
                        </Grid>
                        <Grid size="grow">
                            <Grid container sx={globalstyles.sectionHeader}>
                                <Grid size="grow">
                                    <Typography>
                                        GARA 2
                                    </Typography>
                                </Grid>
                                <Grid size="auto">

                                    <Typography sx={globalstyles.listHeader}>
                                        Soggetti <Chip size="small" color="secondary" label={newElement.cow_list?.length} />
                                    </Typography>
                                </Grid>
                            </Grid>
                            <MyInput
                                id="match_name"
                                label={'Nome'}
                                isError={curElement.match_name === newElement.match_name}
                                value={newElement.match_name}
                                onChange={(ev) => onChangeHandlerNew(ev.target)}
                            />
                            <MyInput
                                id="match_description"
                                label={'Descrizione'}
                                isError={curElement.match_description === newElement.match_description}
                                value={newElement.match_description}
                                onChange={(ev) => onChangeHandlerNew(ev.target)}
                            />
                            <Grid size={6} container alignItems={"end"} alignContent={"center"} sx={{ mb: 1 }}>
                                {newElement.planned_start &&
                                    <DateTimePicker
                                        variant="outlined"
                                        size="small"
                                        sx={{ mt: 0.8 }}
                                        label={'inizio previsto'}
                                        name={'planned_start'}
                                        id={'planned_start'}
                                        slotProps={{ field: { size: 'small' } }}
                                        value={myTimestampToDate(newElement.planned_start)}
                                        onChange={(nv) => onChangeHandlerNew({ value: nv, name: 'planned_start' })} />
                                }
                            </Grid>
                            <Box>
                                <Grid container sx={globalstyles.listHeader}>
                                    <Grid size={0.5}>
                                        Cat
                                    </Grid>
                                    <Grid size={2}>
                                        Matricola
                                    </Grid>
                                    <Grid size="grow">
                                        Nome
                                    </Grid>
                                    <Grid size="grow">
                                        Proprietà
                                    </Grid>
                                    <Grid size={1}>
                                        Parti
                                    </Grid>
                                    <Grid size={1}>
                                        Età (mesi)
                                    </Grid>
                                    <Grid size={1}>
                                        Data di nascita
                                    </Grid>
                                </Grid>
                                {newElement.cow_list?.map((c, k) => (
                                    <OneCow cow={c} key={k} />
                                ))}
                            </Box>
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <MyCloseBtn handleClose={handleClose} />
                    {isEdited &&
                        <Button disabled={checkNotValid()} variant='outlined' key={'sd'} onClick={handleSave} startIcon={<Save />}>Salva</Button>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
})



const OneCow = memo(({ cow, toggleSelect, is_selected, handleDelete, index, handleShow }) => {
    const birthdate = myTimestampToDate(cow.birthdate)
    return (
        <Grid container sx={{ ...globalstyles.list_row, ...globalstyles.elem_row, fontSize: '0.7em' }}>
            {toggleSelect &&
                <Grid size={"auto"}>
                    <IconButton
                        color={"primary"}
                        variant={is_selected ? 'contained' : 'outlined'} onClick={() => toggleSelect(index)} size="small" >{is_selected ? <CheckBox sx={{ fontSize: '1em' }} /> : <CheckBoxOutlineBlank sx={{ fontSize: '1em' }} />}
                    </IconButton>
                </Grid>
            }
            <Grid size={0.5}>
                {cow.catalog_id}
            </Grid>
            <Grid size={2} flexDirection={"row"} container>
                {cow.cow_type === 'red' ?
                    <Tooltip placement="right" title="red">
                        <Box sx={{ backgroundColor: 'red', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
                    </Tooltip>
                    :
                    <Tooltip placement="right" title="black">
                        <Box sx={{ backgroundColor: 'black', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
                    </Tooltip>
                }
                {cow.serial}
            </Grid>
            <Grid size="grow">
                {cow.name}
            </Grid>
            <Grid size="grow">
                {cow.property &&
                    <PropertyLabel element={cow.property} />
                }
            </Grid>
            <Grid size={1}>
                {cow.birth}
            </Grid>
            <Grid size={1}>
                {differenceInMonths(new Date(), birthdate)}
            </Grid>
            <Grid size={1}>
                {format(birthdate, 'dd/MM/yyyy')}
            </Grid>
            <Grid size="auto">
                <PresenceIcon is_present={cow.is_present} />
            </Grid>
        </Grid>
    )

})